import BuyCourseModule from './containers/buyCourseModule'

export {default as BuyCourseModuleLayout} from './components/buyCourseModuleLayout'

export default BuyCourseModule
